

export class StorageDaysStatusInput implements IStorageDaysStatusInput {
    /** The auto-generated id of the storage days master */
    storageDaysId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IStorageDaysStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageDaysId = _data["storageDaysId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StorageDaysStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDaysStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageDaysId"] = this.storageDaysId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStorageDaysStatusInput {
    /** The auto-generated id of the storage days master */
    storageDaysId: number;
    /** The updated status */
    status: number;
}

